import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { msalConfig } from './auth/sso/providers/authProvider';
import './App.css';
import LandingPage from './components/LandingPage';
import SSOLogin from './auth/sso/components/SSOLogin';
import SAPCDCLogin from './auth/sapcdc/components/SAPCDCLogin';
import ForgotPassword from './auth/sapcdc/components/ForgotPassword';
import SignUp from './components/SignUp';
import InstanceSwitch from './components/Adapt-Instances';
import AdaptStudioHub from './components/AdaptStudioHub';
import NotificationPage from './components/ui/NotificationPage';
import MsalTokenProvider from './auth/sso/contexts/MsalTokenProvider';
import TokenHelper from './auth/sso/components/TokenHelper';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import logger from './utils/logger';

// Create MSAL instance - ensure singleton pattern
let msalInstance;
if (!window.msalInstance) {
  msalInstance = new PublicClientApplication(msalConfig);
  window.msalInstance = msalInstance;
} else {
  msalInstance = window.msalInstance;
}

function App() {
  useEffect(() => {
    // Development mode setup
    if (process.env.NODE_ENV === 'development') {
      console.log('🚀 Adapt Authentication App - Development Mode');
      window.logger = logger;
      console.log('🔧 Logging utility available: window.logger');
    }
  }, []);

  return (
    <MsalProvider instance={msalInstance}>
      <MsalTokenProvider>
        <TokenHelper>
          <AuthProvider>
            <Router>
              <div className="App">
                <Routes>
                  {/* Public Routes - No authentication required */}
                  <Route path="/" element={<LandingPage />} />
                  <Route path="/sso-login" element={<SSOLogin />} />
                  <Route path="/sapcdc-login" element={<SAPCDCLogin />} />
                  <Route path="/forgot-password" element={<ForgotPassword />} />
                  <Route path="/signup" element={<SignUp />} />
                  <Route path="/notification" element={<NotificationPage />} />
                  
                  {/* Protected Routes - Require authentication */}
                  <Route
                    path="/home"
                    element={
                      <ProtectedRoute>
                        <AdaptStudioHub />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/instances"
                    element={
                      <ProtectedRoute>
                        <InstanceSwitch />
                      </ProtectedRoute>
                    }
                  />
                </Routes>
              </div>
            </Router>
          </AuthProvider>
        </TokenHelper>
      </MsalTokenProvider>
    </MsalProvider>
  );
}

export default App;
